export const UPDATE_DOMAIN = 'update_domain';
export const ADD_DOMAIN = 'add_domain';
export const DELETE_DOMAIN = 'delete_domain';
export const UPDATE_DOMAINS_FROM_FILE = 'update_domain_from_file';
export const LDAP_IP_ADDED = 'ldap_ip_added';
